
export default {
  name: "blog",
  head() {
    return {
      title: `${(this.article || {}).title || ""} - Blog - ${
        this.$store.getters.store.eshop.name
      }`,
      script: [this.$hyperSeo.ld("article", this.article),{
          hid: "ldBreadcrumbBlog",
          type: "application/ld+json",
          json: this.$hyperSeo.schemas(
            "breadcrumb",
            [{name:'Αρχική',url:'/'},{name:"Blog",url:"/blog"},{name:(this.article || {}).title,url:this.$route.fullPath}]
          ),
        }],
      meta:[...this.$hyperSeo.og(false,"article", this.article),{
          hid: "robots",
          name: "robots",
          content:"index,follow",
        }]
    };
  },
  
  data() {
    return {
      article: {}
    };
  },
  async asyncData({ req, store, route,app, error }) {
   
    let host = "";
    if (process.server) {
      host = req.headers.host + route.fullPath;
    } else {
      host = location.host + route.fullPath;
    }
    let found = await app.$hyperBlog.getArticles('slug',route.params.blog,1,1,false,false);
    let article = (found || [])[0];
    // getArticles returns undefined when the API call itself failed. That is a
    // 5xx, not a missing article -- answering 404 on a hiccup would drop a live
    // page out of Google.
    if (!found) {
      return error({ statusCode: 503, message: 'Προσωρινό πρόβλημα, δοκιμάστε ξανά' });
    }
    // Deleted or disabled: the API filters those out, so there is nothing to
    // render and head() threw on article.title -- a 5xx where the page should
    // simply not exist (#23545).
    if (!article) {
      return error({ statusCode: 404, message: 'Δεν βρέθηκε το άρθρο' });
    }
    article = await app.$hyperBlog.parseArticle(article);
    return { article };
  },
  
  mounted() {
    if (this.$route.params.blog) {
      // this.getArticle(`&slug=${this.$route.params.blog}`);
      return;
    }
  },
};
